'use strict';

// LP離脱時に <html> の lp-html クラス（scroll-behavior: smooth）を確実に外す。
// Turbolinksは <body> しか差し替えず <html> 要素は保持するため、このクラスが
// 遷移先（役一覧・点数表など）に残ると、Turbolinksのスクロールトップ復元まで
// smooth 化されてしまい、ページ先頭から表示されない不具合になる。
// スクロール復元より前の before-render で除去し、load では LP のときだけ再付与する。
(function() {
  const HTML_CLASS = 'lp-html';

  function isLandingBody(body) {
    return !!body && body.classList.contains('lp-body');
  }

  // 遷移先がLPでなければ、スクロール復元前にクラスを外す。
  document.addEventListener('turbolinks:before-render', function(event) {
    if (!isLandingBody(event.data.newBody)) {
      document.documentElement.classList.remove(HTML_CLASS);
    }
  });

  // 現在のページがLPなら付与、そうでなければ除去（初回ロード・LP再訪時の同期）。
  document.addEventListener('turbolinks:load', function() {
    document.documentElement.classList.toggle(HTML_CLASS, isLandingBody(document.body));
  });
})();
